"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fromV0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _util = require("@plugnet/util");

var _createFunction = _interopRequireDefault(require("./createFunction"));

var _storage = require("./storage");

// Copyright 2017-2019 @polkadot/storage authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * Extend a storage object with the storage modules & module functions present
 * in the metadata.
 *
 * @param storage - A storage object to be extended.
 * @param metadata - The metadata to extend the storage object against.
 */
function fromV0(metadata) {
  return metadata.modules.reduce((result, moduleMetadata) => {
    if (moduleMetadata.storage.isNone) {
      return result;
    }

    const prefix = moduleMetadata.storage.unwrap().prefix; // For access, we change the index names, i.e. Balances.FreeBalance -> balances.freeBalance

    result[(0, _util.stringLowerFirst)(prefix.toString())] = moduleMetadata.storage.unwrap().functions.reduce((newModule, func) => {
      newModule[(0, _util.stringLowerFirst)(func.name.toString())] = (0, _createFunction.default)(prefix, func.name, func);
      return newModule;
    }, {});
    return result;
  }, (0, _objectSpread2.default)({}, _storage.storage));
}